import React from 'react';
import { Box, InputAdornment, TextField } from '@mui/material';

const CustomTextfield = ({
  ele,
  handleInput,
  props,
  register,
  errors,
  formError,
  handleDisable,
  handelNegativeInput,
  dummyFunctiom,
  disableGarage, 
  numberInputOnWheelPreventChange
}) => {
  const excludedNames = ['demandNo', 'chequeNo', 'accountNo'];
  
  return (
    <Box className="customTextField flex-1">
      <TextField
        className={ele?.className}
        placeholder={ele?.placeholder}
        {...register(ele?.name, {
          required:  (ele?.name === 'configRate' && disableGarage?.required) ||ele?.required || false,
        })}
        type={ele?.type}
        error={!!(errors[ele?.name] || formError[ele?.name])}
        onChange={(e) => {
          handleInput(e);
        }}
        disabled={handleDisable(ele?.fieldDisabled, props?.disabled, ele?.name) || (ele?.name === 'configRate' && disableGarage?.disable)}
        multiline={ele?.multiline || false}
        rows={ele?.row || ''}
        defaultValue={ele?.defaultValue}
        onWheel={numberInputOnWheelPreventChange}
        InputProps={{
          inputProps: {
            min: ele?.type === 'number' && !excludedNames.includes(ele?.name) ? 1 : '',
            step: ele?.name === 'amount' || ele?.name === 'tds' ? '0.01' : '',
          },
          startAdornment: ele?.rupee && (
            <InputAdornment position="start">₹</InputAdornment>
          ),
          onInput: ele?.type === 'number' ? handelNegativeInput : dummyFunctiom,
        }}
        onKeyDown={(e) => {
          if (e.which === 38 || e.which === 40) {
            e.preventDefault();
            return;
          }
        }}
      />
    </Box>
  );
};

export default CustomTextfield;
